<div
  class="message-item-wrapper pointer"
  fxLayoutAlign="space-between center"
  (click)="routeLink()"
  routerLinkActive="active-details"
>
  <div class="left-side" fxLayoutAlign="flex-start center">
    <div class="img-wrapper mr-25" fxLayoutAlign="center center">
      <img src="assets/images/message/message.svg" alt="message" />
      <div *ngIf="!messageData.read" class="red-dot"></div>
    </div>
    <div
      class="message-content-wrapper"
      fxLayout="column"
      fxLayoutAlign="center start"
    >
      <span
        class="message-title text-black"
        [ngClass]="!messageData.read ? 'font-bold' : ''"
        >{{ messageData.title }}</span
      >
    </div>
  </div>
  <div class="right-side">
    <div class="next-wrapper">
      <img src="assets/images/message/next.svg" alt="arrow-right" />
    </div>
  </div>
</div>
